window.addEventListener("load", (event) => {
  // console.log("footer is fully loaded");
  if (window.innerWidth < 768) {
    const marquee = new Swiper('.marquee-gallery', {
      wrapperClass: 'footer-gallery__track',
      slideClass: 'site-footer__block',
      speed: 500,
      spaceBetween: 60,
      preventInteractionOnTransition: true,
      loop: true,
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      autoplay: {
        delay: 3000,
      }
    });
  }
});